import { Injectable, signal } from '@angular/core';

export interface TrialDialogData {
  place: string;
  title: string;
  subtitle?: string;
  button?: string;
  isMuseum?: boolean;
}

@Injectable({ providedIn: 'root' })
export class TrialDialogService {
  private _trialData = signal<TrialDialogData | null>(null);
  public get trialData() {
    return this._trialData.asReadonly();
  }

  public closeDialog() {
    this._trialData.set(null);
  }

  public openDialog(config: TrialDialogData) {
    this._trialData.set(config);
  }
}
